<template>
    <div class="dutyGoods_container">
        <div class="searh">
            <div class="searh_top">
                <a-button type="primary" @click="reserves" :disabled="val.length < 1">设为库存</a-button>
                <a-button type="primary" @click="transfer" :disabled="val.length< 1">移交</a-button>
                <!-- <a-button type="primary" @click="scrap" :disabled="val.length < 1">报废</a-button> -->
            </div>
            <div>
                   <!-- <a-tree-select allowClear :treeData="departList" placeholder="请选择部门"  v-model="storage.departId" style="width: 200px; margin-right: 10px;"
							 @change="selectDepartment" >
				</a-tree-select> -->
                <a-select allowClear placeholder="请选择资产类别" v-model="storage.assetTypeName" @change="getAssetTypeName" style="width: 200px; margin-right: 10px;">
                        <a-select-option :value="item.dictCode" v-for="(item, index) in assetTypeList" :key="index" >
                            {{ item.dictLabel }}
                        </a-select-option>
				</a-select>
                <!-- @keyup.enter.native="" -->
                 <a-input placeholder="物品编号" class="a_input_self margin_self" v-model="storage.assetSn" />
                <a-input placeholder="物品名称" class="a_input_self margin_self" v-model="storage.name" />
                <a-button type="primary" @click="searchStorage" style="margin-left: 15px;">查询</a-button>
                <a-button type="primary" @click="restetStorage">重置</a-button>
            </div>
               
        </div>
        <div class="tables">
             <a-table
                  :pagination="false"
                  :scroll="{ x: 1500, y: 350 }"
                 @change="handleTableChange"
                  :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
                  :columns="columns"
                 :data-source="keeperList"
                 />
        </div>
         <div class="pageBottom">
                               <a-pagination
            v-model="pagination.current"
            show-size-changer
            :page-size.sync="pagination.pageSize"
            :total="pagination.totalCount"
			@showSizeChange="onShowSizeChange"
            :pageSizeOptions="['10', '20', '30','40', '50']"
            @change="onShowSizeChange"
          />
            </div> 
         <!-- <Pagination 
              v-model="pagination.current"
              :total="pagination.total"
              show-size-changer
              :page-size="pagination.pageSize"
              @onShowSizeChange="onShowSizeChange"
              ></Pagination> -->
        <!-- 设为库存 -->
        <a-modal class="gufiiguy" title="设为库存" :visible="reservesVisible" @cancel="closeReserves" width="70%" @ok="reserveGoods">
                
                    <div class="headline">物品信息</div>
                
                <div class="scrap_body">
                 <a-table
                     :pagination="false"
                     :columns="reservesColumns"
                     :data-source="reservesData"
                   />
            </div>
        </a-modal>
        <!-- 移交 -->
          <Receive :replaceTypes="types" :replaceVisible="replaceVisible" @visibleState="visibleState" :transferVal="transferVal" @put="getKeeperAsset_list()"></Receive>
        <!-- <a-modal class="gufiiguy" title="确认移交" :visible="transferVisible" @cancel="transferVisible = false" width="70%">
        <Receive></Receive>
        </a-modal> -->
        <!-- 报废 -->
        <!-- <a-modal class="gufiiguy" title="固定资产-离职报废" :visible="scrapVisible" @cancel="closeScrap" width="70%" @ok="scrapAsset">
           <div class="headline" >物品信息</div>
                <div class="scrap_body">

                  <a-form-model :model="scrapForm" :rules="rules" ref="ruleForm" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
                   
                    <a-row>
					    <a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
						    <ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
                            
					    </a-form-model-item>
				    </a-row>
                    <a-row>
					    <a-form-model-item label="报废原因" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }"  prop="reason" :rules="{
					  required: true,
					  message: '请输入报废原因',
					  trigger: 'change',
					}">
						 	<a-input  v-model="scrapForm.reason" allowClear placeholder="请输入"/>
					    </a-form-model-item>
				    </a-row>
                    <a-row>
                        <div class="tables">
                            <a-table :columns="scrapColumns" :data-source="scrapList"/>
                        </div>
                    
                    </a-row>
            </a-form-model>
                </div>

           
         
        </a-modal> -->
         <!-- :data="ccC"@targetKeys="getdata" v-if="isRouterAlive"  -->

    </div>
</template>
<script>
import Receive from '../components/rceive.vue'
import ccChange from '@/components/module/ccChange'
import Pagination from '@/components/pagination/index.vue'
import { dutyAsset_list, replaceDuty_put, assetType_get} from '@/api/Industry'
import { tree_all } from '@/api/purchase'
import { checkin } from '@/api/assetmenag'
import { keep_storage } from '@/api/Industry'

// import { defineComponent } from '@vue/composition-api'
import { keeperAsset_list} from '@/api/Industry'
import { scrapped_apply } from '@/api/assetmenag'

export default{
    components: {
        Receive,
        ccChange,
        Pagination

    },
    props: [ 'userName'],
    data() {
        return {
            isRouterAlive: false,
            scrapData: [],
            dataVal: [],
            reservesData: [],
            types: 0,
            storage: {},
            assetTypeList: [],
            // departList: [],
             selectedRowKeys: [],
             ccC: '',
            // scrapForm: {
            //     cc: []
            // },
            scrapList: {},
            //报废
            scrapVisible: false,
            //设为库存
            reservesVisible: false,
            //移交
            transferVisible: false,
            goods: {
                loginName: ''

            },
            columns: [
                 {
                    title: '物品编号',
                    dataIndex: 'assetSn',
                     ellipsis: true,
                },
                {
                    title: '资产类别',
                    dataIndex: 'assetTypeName',
                     ellipsis: true,
                },
                {
                    title: '物品状态',
                    dataIndex: 'goodStatus',
                     ellipsis: true,
                },
                 {
                    title: '物品名称',
                    dataIndex: 'name',
                     ellipsis: true,
                },
                 {
                    title: '规格型号',
                    dataIndex: 'model',
                     ellipsis: true,
                },
                 {
                    title: '物品单价',
                    dataIndex: 'singlePrice',
                     ellipsis: true,
                },
            ],
            reservesColumns:  [
                 {
                    title: '物品编号',
                    dataIndex: 'assetSn',
                     ellipsis: true,
                },
                {
                    title: '资产类别',
                    dataIndex: 'assetTypeName',
                     ellipsis: true,
                },
               {
                    title: '物品名称',
                    dataIndex: 'name',
                     ellipsis: true,
               },
               {
                    title: '规格型号',
                    dataIndex: 'model',
                     ellipsis: true,
                }
            ],
            scrapColumns: [
                 {
                    title: '资产类别',
                    dataIndex: 'assetTypeName',
                     ellipsis: true,
                },
                  {
                    title: '物品名称',
                    dataIndex: 'name',
                     ellipsis: true,
                },
                  {
                    title: '物品编号',
                    dataIndex: 'assetSn',
                     ellipsis: true,
                },
                  {
                    title: '规格型号',
                    dataIndex: 'model',
                     ellipsis: true,
                },
                  {
                    title: '物品状态',
                    dataIndex: 'goodStatus',
                     ellipsis: true,
                },
                  {
                    title: '采购时间',
                    dataIndex: 'purchaseTime',
                },
                  {
                    title: '采购价格',
                    dataIndex: 'singlePrice',
                     ellipsis: true,
                },
                  {
                    title: '当前估值',
                    dataIndex: 'id',
                     ellipsis: true,
                },
                  {
                    title: '责任人',
                    dataIndex: 'charger',
                     ellipsis: true,
                },
                  {
                    title: '责任部门',
                    dataIndex: 'belongDept',
                     ellipsis: true,
                },
            ],
            keeperList: {},
             list: {},
              pagination:{ //分页数据
			     pageSizeOptions: ['10', '20', '30', '40', '50'],
                 current : 1,
                 pageSize: 10,
                 totalCount: 0
            },
            //    pagination: {
			// 		current: 1,
			// 		pageSize: 10,
			// 		total: 0,
			// 		pageSizeOptions: ['10', '20', '30', '40', '50'],
			// 		showSizeChanger: true,
			// 		itemName: '',
			// 		hideOnSinglePage:false
			// 	},
            replaceVisible: false,
            val: [],
            transferVal: []

        }
    },
    created() {
        this.getKeeperAsset_list()
        // //获取部门
        //    tree_all().then(res => {
        //     console.log(res, 'res')
        //     let companyList = res.data[0]
        //     console.log(companyList, 'companyList')
        //     let companyId = this.$store.state.user.info.companyId
        //     // if(!companyList) {
        //          companyList.forEach(item => {
        //         if( item.deptId == companyId) {
        //           this.departList = item.children
        //            this.departList.forEach(item3 => {
        //         item.value = item3.title
        //         item.title = item3.title
        //      if(item.children) {
        //         item3.children.forEach( item1 => {
        //         item1.value = item1.title
        //         item1.title = item1.title
        //          item1.children.forEach( item2 => {
        //         item2.value = item2.title
        //         item2.title = item2.title
        //      })
        //      })
        //   }
        //   return this.departList
        //            })

        //         }
                
        //     });
        
        //     })
            //获取资产类别
            assetType_get({
                dictType: 'assets_type'
            }).then(res => {
                this.assetTypeList = res
                console.log(this.assetTypeList, 'this.assetTypeList++++++++++++++++++++++++++++++')

            })
    },
        methods: {
            //取消设为库存
            closeReserves() {
                this.reservesVisible = false
                this.selectedRowKeys = ''
                this.reservesData = []
                this.val = []

            },
            //设为库存
            reserveGoods() {
                   let reservesData = this.reservesData.map(item=>{
                  // 每一项的id
                  return item.id
                })
                console.log('111111111111111111111111111111111111111111111')

                keep_storage(reservesData).then((res) => {
                  if (res.code === 200) {
                   this.$message.success('保存成功')
                    this.selectedRowKeys = ''
                     this.reservesData = []
                   //刷新列表
                   this.getKeeperAsset_list()
                   //关闭弹窗
                   this.reservesVisible = false
                   
               }
                })

            },
            // getdata(data) {
            //     console.log(data, 'data===============================')
			// 	this.scrapForm.cc = data
            //      console.log(this.scrapForm.cc, 'this.scrapForm.cc===============================')
			// },
            //取消报废
            // closeScrap() {
            //     this.scrapVisible = false
            //     this.scrapForm.reason = ''
            //     this.val = []
            //     this.scrapList = []
            //     this.selectedRowKeys = ''

            // },
            //提交报废
            // scrapAsset() {
            //     this.$refs.ruleForm.validate((valid) => {
			// 		if (valid) {
            //                console.log(this.scrapList, 'this.scrapList===================')
            //       let scrapList = this.scrapList[0].id
            //       // 每一项的id
            //     //   return item.id
            //     // })
            //     // this.reservesData
            //   scrapped_apply({
			// 				cc:  this.scrapForm.cc.length ? this.scrapForm.cc.join(',') : '',
			// 				assertId: scrapList,
			// 				remark: this.scrapForm.reason,
			// 			}).then((res) => {
			// 				console.log(res)
			// 				if (res.code != 200) {
			// 					this.$message.error(res.msg)
			// 					return
			// 				}
            //                 this.$refs.ruleForm.resetFields()
			// 				this.$message.success('报废成功！')
            //                 //刷新列表
            //                 this.getKeeperAsset_list()
            //                 this.scrapVisible = false
            //                 this.scrapList = []
            //                  this.selectedRowKeys = ''
			// 				// this.selectedRowKeys2 = []
			// 				// this.profitvisible = false
			// 			})

            //         }
            //     })
             
            // },
        visibleState(data) {
            this.val = data.val
            this.replaceVisible = data.replaceVisible
            this.transferVal = data.transferVal
            this.selectedRowKeys = data.selectedRowKeys
            // console.log(this.val, 'this.val==================')
        },
            getAssetTypeName(e) {
                this.$forceUpdate()

            },
          restetStorage() {
            this.storage = []
            this.getKeeperAsset_list()

            },
        //查询事件
        searchStorage() {
            this.loading = true
       this.pagination.current = 1
	   this.getKeeperAsset_list()

        },
        //      selectDepartment(e) {
        //     this.duty.deptId = e
        // },
         onShowSizeChange(current, pageSize) {
        console.log(current, pageSize);
        this.pagination.current = current
        this.pagination.pageSize = pageSize;
        //改变完 重新渲染数据
       this.getKeeperAsset_list()
      },
        onSelectChange(selectedRowKeys, val) {
            console.log(selectedRowKeys, val, 'val=====================================')
            this.selectedRowKeys = selectedRowKeys
            this.val = val
            this.transferVal = val
            this.dataVal = val
        },
        //改变分页
        handleTableChange(pagination, filters, sorter) {
            this.pagination.current = pagination.current
            this.getKeeperAsset_list()
        },
         //获取数据    
         getKeeperAsset_list() {
        keeperAsset_list({
           keeper: this.userName,
           pageIndex: this.pagination.current,
		   pageSize: this.pagination.pageSize,
           assetSn: this.storage.assetSn,
           assetType: this.storage.assetTypeName,
           name: this.storage.name
           }).then(res => {

          this.keeperList = res.rows
            keeperAsset_list({
           keeper: this.userName,
           pageIndex: this.pagination.current,
		   pageSize: this.pagination.pageSize,
           }).then(res => {
               if(res.total == 0){
                   this.$emit("secondTab",  this.keeperList)
               }
           })
          this.pagination.total = res.total
           console.log(res, 'res=============================')
           console.log(this.keeperList, 'this.keeperList=============================')

       })
              },
            transfer() {
                // this.transferVisible = true
                //  if(this.dataVal.length > 1){
                //      this.$message.warning('每次只能选择一个物品移交！')
                //     return 
                // } else {
               this.replaceVisible  = true
                this.types = 0 
                // }

                console.log('111111111111111111111111111111111111')
               
            },
            reserves() {
                // if(this.dataVal.length > 1){
                //      this.$message.warning('每次只能选择一个物品设为库存！')
                //     return 
                // } else {
                this.reservesVisible = true
                this.reservesData = this.dataVal
                // }

            },
            // scrap() {
               
            //     if(this.dataVal.length > 1){
            //         this.$message.warning('每次只能选择一个物品报废！')
            //         return 
            //     } else {
            //          this.isRouterAlive = false
			// 	this.$nextTick(() => {
			// 		this.isRouterAlive = true
			// 	})
            //     this.scrapVisible = true
            //     this.scrapList = this.dataVal
            //     }
            // }

    }
  
}
</script>
<style>
.dutyGoods_container {
    /* padding: 20px; */

}
.scrap_body {
    background-color: #fff;
    padding: 10px;
    margin: 0 25px 30px 25px;
    border-radius: 15px;
}
.tables {
    margin-top: 20px;

}
.scrap_body {
    background-color: #f8f8f8;
    padding: 20px 10px 10px;
     font-size: 20px;
}
.searh_top {
    margin: 5px 0 15px;
}
.headline {
    font-size: 20px;
    margin: 20px;
}
</style>
